/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { integrationAdaptersApiPath } from '../settings';
import { getAccessToken } from '../redux/features/auth/auth.service';
import { httpRequest } from '../shared/http';

const axios = require('axios').default;

const { CancelToken } = axios;
let cancel;

const getHeaders = () => {
  const token = getAccessToken();
  if (token) {
    return {
      'Cache-Control': 'no-cache',
      Authorization: `Bearer ${token}`,
    };
  }
  return { 'Cache-Control': 'no-cache' };
};

export default {
  get: async (endpoint) => {
    if (cancel !== undefined) {
      cancel();
    }
    return axios
      .get(`${integrationAdaptersApiPath}/${endpoint}`, {
        cancelToken: new CancelToken(function executor(c) {
          cancel = c;
        }),
        headers: getHeaders(),
      })
      .then(response => response?.data || null)
      .catch(() => Promise.resolve(null));
  },

  getByApplicationNumber: async (applicationNumber, protectionSelection, options) => {
    const url = `${integrationAdaptersApiPath}/submissions/application/${applicationNumber}/${protectionSelection}`;
    const { data: resp } = await httpRequest(url, {
      method: 'GET',
      ...options,
    })();
    return resp;
  },

  getByPublicationNumber: async (publicationNumber, protectionSelection, options) => {
    const url = `${integrationAdaptersApiPath}/submissions/publication/${publicationNumber}/${protectionSelection}`;
    const { data: resp } = await httpRequest(url, {
      method: 'GET',
      ...options,
    })();
    return resp;
  },
};
